module.exports = "/images/active-shooter@3x.png?a4ab4e251c779ffd2938b91e6c08c91a";